import React, { useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { Container, PageContainer } from '../../components'
import { Box, Button, Grid } from '@mui/material'
import { useStyles } from './styles'
import { useTenant } from '@emerald-works-nova/auth'
import { AccountCircleTwoTone } from '@mui/icons-material'
import B2CAuthAppBar from '../../components/b2c-auth-app-bar'
import consts from '../../consts'
import PaidPlansCTA from './components/paid-plans-cta'
import { routes } from './../../routes'
import { useDispatch, useSelector } from 'react-redux'
import { b2cSignupSlice } from '../../reducers'
import { ProgressBar, REVIEW_AND_PAYMENT_STEP } from './components/progress-bar'
import { FormProvider } from './context'
import AccountInfoForm from './components/account'
import PaymentInfoForm from './components/payment'
import OrderSummary from './components/order-summary'
import { fetchPlans, setDefaultPlan } from '../../reducers/b2c-signup/slice'
import { Elements, RecurlyProvider } from '@recurly/react-recurly'
import { useEventsOnViewLoad } from '@emerald-works/react-event-bus-client'
import clsx from 'clsx'
import { Auth } from '@aws-amplify/auth'

const B2CSignUp = ({ isFree }) => {
  const tenant = useTenant()
  const classes = useStyles()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const params = useParams()
  const { plan: planId } = params

  dispatch(setDefaultPlan(planId))

  const goToLogin = () => navigate('/login')
  const currentStep = useSelector(b2cSignupSlice.selectors.selectCurrentStep)

  const [loggedIn, setLoggedIn] = React.useState(false)

  useEffect(() => {
    const checkAuthUser = async () => {
      const auth = await Auth.currentAuthenticatedUser().catch(() => null)
      if (auth) {
        setLoggedIn(true)
        dispatch(b2cSignupSlice.actions.setCurrentStep(REVIEW_AND_PAYMENT_STEP))
      }
    }
    checkAuthUser()
  }, [dispatch])

  useEffect(() => {
    // Ensure b2c register only for club tenant
    if (tenant && tenant.pk !== consts.DEFAULT_CLUB_PK) {
      navigate(routes.register.path)
    }
  }, [tenant, navigate])

  useEventsOnViewLoad(() => {
    dispatch(fetchPlans(planId))
  }, [dispatch])

  return (
    <>
      <B2CAuthAppBar
        rightSlot={loggedIn
          ? (
              null
            )
          : <Button startIcon={<AccountCircleTwoTone />} onClick={goToLogin} variant='outlined'>Sign In</Button>}
      />
      <PageContainer>
        <RecurlyProvider publicKey={process.env.REACT_APP_RECURLY_JS_API_KEY}>
          <Container className={classes.container} maxContentWidth='100%' inset={3}>
            <Grid className={clsx(classes.contentGrid, currentStep === REVIEW_AND_PAYMENT_STEP && classes.contentGridPayment)}>
              <Box className={classes.progress}>
                <ProgressBar currentStep={currentStep} />
              </Box>
              <FormProvider>
                <Elements>
                  <Box className={classes.personalInfo}>
                    <AccountInfoForm />
                  </Box>
                  <Box className={classes.paymentInfo}>
                    <PaymentInfoForm />
                  </Box>
                  <Box className={classes.orderSummary}>
                    <OrderSummary />
                  </Box>
                </Elements>
              </FormProvider>
            </Grid>

            <Grid item xs={12} lg={5}>
              {isFree && (
                <Box mt={2} mb={2}>
                  <PaidPlansCTA />
                </Box>
              )}
            </Grid>
          </Container>
        </RecurlyProvider>
      </PageContainer>
    </>
  )
}

const B2CSignUpFree = () => {
  return (
    <B2CSignUp isFree />
  )
}

export {
  B2CSignUp as Component,
  B2CSignUpFree
}
